import React from "react";
const SvgLoginCallAssistance = props => (
  <svg fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M6.944 12.056A9.055 9.055 0 0116 3a9.055 9.055 0 019.055 9.056v.638a.75.75 0 11-1.5 0v-.638a7.555 7.555 0 10-15.11 0v.638a.75.75 0 11-1.5 0v-.638zM15.207 24.8a.847.847 0 100 1.694h1.598a.847.847 0 100-1.694h-1.598zm-2.347.847a2.347 2.347 0 012.348-2.347h1.597a2.347 2.347 0 110 4.694h-1.598a2.347 2.347 0 01-2.347-2.347z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M23.667 20.889a.75.75 0 01.75.75v1.333c0 1.85-1.456 3.417-3.306 3.417H18.39a.75.75 0 010-1.5h2.721c.962 0 1.806-.834 1.806-1.917V21.64a.75.75 0 01.75-.75z"
      clipRule="evenodd"
    />
    <path
      fill="#E4002B"
      d="M7.056 12.694h1.277c.703 0 1.278.575 1.278 1.278v6.39c0 .702-.575 1.277-1.278 1.277H7.056A2.563 2.563 0 014.5 19.083V15.25a2.563 2.563 0 012.556-2.556zm16.611 0h1.277A2.563 2.563 0 0127.5 15.25v3.833a2.563 2.563 0 01-2.556 2.556h-1.277a1.282 1.282 0 01-1.278-1.278v-6.389c0-.702.575-1.277 1.278-1.277z"
    />
  </svg>
);
export default SvgLoginCallAssistance;
